import React from "react";
import { useSelector } from "react-redux";
import "./print.css";
import moment from "moment";
import { selectCompanyAddress } from "../utility/Redux/profile";
const IssuePrint = ({ data, rows, partyDetails }) => {
  const { columns } = data;
  const companyDetails = useSelector(selectCompanyAddress);

  return (
    <div
      style={{
        padding: "20px",
        border: "1px solid black",
        fontFamily: "Arial, sans-serif",
        fontSize: "12px",
      }}
    >
      <div id="print-component">
        {/* Header Section */}
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <div style={{ fontWeight: "bold", fontSize: "16px" }}>
            {companyDetails?.companyName}
          </div>
          <div style={{ fontWeight: "500", fontSize: "14px" }}>
            {companyDetails?.address +
              "," +
              companyDetails?.city +
              "," +
              companyDetails?.mobile}
          </div>
          <p style={{ fontSize: "14px", fontWeight: "600" }}>Debit Note</p>
        </div>

        {/* Seller Information */}
        <div style={{ marginBottom: "10px" }}>
          <div className="flex justify-between mb-1 border-b  pb-1">
            <div className="flex" style={{}}>
              <div style={{ width: "170px", fontWeight: "bold" }}>
                {" "}
                Debit Note No.
              </div>{" "}
              :<div className="ml-1">{partyDetails.DEBIT_NOTE_NO}</div>
            </div>

            <div className="flex">
              {" "}
              <div className="mr-1" style={{ fontWeight: "bold" }}>
                Date :
              </div>
              {moment(partyDetails.DATE).format("YYYY-MM-DD")}
            </div>
          </div>

          <div className="flex justify-between">
            <div className="b flex" style={{}}>
              <div style={{ width: "170px", fontWeight: "bold" }}>
                Party Name{" "}
              </div>{" "}
              :<div className="ml-1 ">{partyDetails.NAME}</div>
            </div>
          </div>
        </div>

        {/* Itemized Table */}
        <table
          style={{
            border: "1px solid black",
            marginTop: "20px",
            marginBottom: "20px",
            width: "100%",
          }}
        >
          <thead>
            <tr>
              {columns.map((c) => (
                <th
                  style={{
                    border: "1px solid black",
                    fontWeight: "bold",
                    padding: "5px",
                  }}
                  key={c.field}
                >
                  {c.headerName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, index) => (
              <tr key={index}>
                {columns.map((c) => (
                  <td
                    style={{
                      border: "1px solid black",
                      padding: "5px",
                      textAlign: c.align ? c.align : "left",
                    }}
                    key={c.field}
                  >
                    {r[c.field]}
                  </td>
                ))}
              </tr>
            ))}
            <tr>
              {columns.map((c) => (
                <td
                  style={{
                    border: "1px solid black",
                    padding: "5px",
                    fontWeight: "600",
                    textAlign: "right",
                  }}
                  key={c.field}
                >
                  {c.field === "PACKING" && "Total Qnty"}
                  {c.field === "QNTY" &&
                    rows.reduce((acc, row) => acc + Number(row.QNTY), 0)}
                  {c.field === "AMOUNT" &&
                    rows.reduce((acc, row) => acc + Number(row.AMOUNT), 0)}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default IssuePrint;
